"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const components_common_inputs_1 = require("@hotelplan/components.common.inputs");
const AutocompleteContext_1 = require("./AutocompleteContext");
const AutocompleteTag_1 = __importDefault(require("./AutocompleteTag"));
const useAutocompleteKeyboardControl_1 = __importDefault(require("./useAutocompleteKeyboardControl"));
const AutocompleteInputWrap = styled_components_1.default.div(({ theme }) => theme.autocomplete.inputWrapStyles);
function AutocompleteInput(props) {
    const { className, getTagName, renderTagLabel, disableAutocompleteTags } = props, rest = __rest(props, ["className", "getTagName", "renderTagLabel", "disableAutocompleteTags"]);
    const ctx = (0, AutocompleteContext_1.useAutocompleteContext)();
    const onWrapperClick = () => {
        var _a;
        (_a = ctx.inputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    };
    (0, useAutocompleteKeyboardControl_1.default)(disableAutocompleteTags);
    (0, react_1.useEffect)(() => {
        if (disableAutocompleteTags) {
            const selected = ctx.selectedItems
                .map(item => item.name)
                .join(', ');
            ctx.setValue(selected);
        }
    }, [disableAutocompleteTags, ctx.selectedItems]);
    return (react_1.default.createElement(AutocompleteInputWrap, { "data-id": "input-wrapper", className: className, onClick: onWrapperClick },
        !disableAutocompleteTags ? (react_1.default.createElement(react_1.default.Fragment, null, ctx.selectedItems.map((item, index) => (react_1.default.createElement(AutocompleteTag_1.default, { key: index, active: ctx.isLastToRemove && index === ctx.selectedItems.length - 1, name: getTagName(item), label: renderTagLabel(item, ctx.value), onRemove: () => ctx.removeItem(item) }))))) : null,
        react_1.default.createElement(components_common_inputs_1.BaseInput, Object.assign({ inputRef: ctx.inputRef, "data-id": "query-input", hideLabel: true, value: ctx.value, onChange: e => ctx.setValue(e.target.value), spellCheck: false, autoComplete: "off", autoCapitalize: "none" }, rest))));
}
exports.default = AutocompleteInput;
//# sourceMappingURL=AutocompleteInput.js.map